import { Card, Space } from 'antd';
import React from 'react';
import { Company } from '../../models/company-interface';

interface CompanyAddressCardProps {
  company: Company | undefined;
}

export default function CompanyAddressCard({
  company,
}: CompanyAddressCardProps) {
  if (!company?.address1?.length || !company?.stateProvince?.length)
    return null;

  return (
    <Card>
      <Space direction='vertical'>
        <b>ADDRESS</b>
        <p>
          {company.address1}
          <br />
          {!!company.address2 && company.address2}
          {!!company.address2 && <br />}
          {`${company.city}, ${company.stateProvince} ${company.postalCode}`}
          <br />
          {company.country}
        </p>
      </Space>
    </Card>
  );
}
